module.exports = __webpack_public_path__ + "static/media/flow.8badcdec.png";